/** Persistent route shell for the eligibility worklist and patient details. */

import { useEffect, useState } from "react";
import { Outlet, useMatch } from "react-router-dom";
import { PatientEligibilityMapping } from "./PatientEligibilityMapping";

/**
 * Keep the worklist mounted while patient details are open so returning does
 * not reset its active tab or repeat its landing requests.
 *
 * @returns The retained worklist and the active detail route
 */
export function EligibilityWorklistRoute() {
  const isPatientDetailsOpen = Boolean(
    useMatch("/eligibility/:trialId/:mrn"),
  );
  const [hasMountedWorklist, setHasMountedWorklist] = useState(
    () => !isPatientDetailsOpen,
  );

  useEffect(() => {
    if (!isPatientDetailsOpen) {
      setHasMountedWorklist(true);
    }
  }, [isPatientDetailsOpen]);

  return (
    <div className="h-full min-h-0">
      {hasMountedWorklist ? (
        <div className={isPatientDetailsOpen ? "hidden" : "h-full min-h-0"}>
          <PatientEligibilityMapping />
        </div>
      ) : null}
      {isPatientDetailsOpen ? (
        <div className="h-full min-h-0">
          <Outlet />
        </div>
      ) : null}
    </div>
  );
}
